var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.96721403300762, 8.381903171539307e-7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.36 0.00 C 6.09 0.00 4.21 1.72 3.96 3.93 L 0.00 3.93 L 0.00 4.92 L 3.96 4.92 C 4.21 7.13 6.09 8.85 8.36 8.85 C 10.80 8.85 12.79 6.87 12.79 4.43 C 12.79 1.99 10.80 0.00 8.36 0.00 M 7.38 6.60 L 6.05 5.27 L 6.74 4.57 L 7.38 5.21 L 9.98 2.60 L 10.68 3.30 L 7.38 6.60",
    fill: "#4b1498",
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.789345189929008, 10.819672469049692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.60 0.00 L 4.13 0.00 L 4.13 12.30 C 4.13 13.11 3.47 13.77 2.65 13.77 L 0.19 13.77 L 0.19 14.26 C 0.19 14.77 0.12 15.27 0.00 15.74 L 5.60 15.74 C 5.88 15.74 6.10 15.52 6.10 15.25 L 6.10 0.49 C 6.10 0.22 5.88 0.00 5.60 0.00",
    fill: "#4b1498",
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.151312276721001, 11.803278807550669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.00 0.20 C 0.09 0.64 0.49 0.98 0.96 0.98 C 1.44 0.98 1.84 0.65 1.93 0.20 C 1.63 0.07 1.31 0.00 0.96 0.00 C 0.62 0.00 0.30 0.07 0.00 0.20",
    fill: "#4b1498",
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.14754144847393, 6.1568855084478855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.98 4.66 L 2.95 4.66 C 3.49 4.66 3.93 4.22 3.93 3.68 L 3.93 0.73 L 3.63 0.73 C 2.74 0.73 1.90 0.47 1.20 0.00 C 0.82 0.24 0.42 0.43 0.00 0.59 L 0.00 3.68 C 0.00 4.22 0.44 4.66 0.98 4.66",
    fill: "#4b1498",
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.180328533053398, 6.885246638208628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.98 1.97 L 0.98 0.00 C 0.44 0.00 0.00 0.44 0.00 0.98 C 0.00 1.53 0.44 1.97 0.98 1.97",
    fill: "#4b1498",
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.983606740832329, 7.868852976709604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.00 15.74 L 2.46 15.74 C 2.73 15.74 2.95 15.52 2.95 15.25 L 2.95 0.49 C 2.95 0.22 2.73 0.00 2.46 0.00 L 0.98 0.00 L 0.98 12.30 C 0.98 12.94 0.57 13.48 0.00 13.68 L 0.00 15.74",
    fill: "#4b1498",
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.050655767321587, 12.596065405756235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.96 2.16 L 1.52 2.16 L 1.52 1.67 C 1.52 1.02 1.27 0.44 0.86 0.00 C 0.69 0.40 0.38 0.72 0.00 0.93 C 0.47 1.19 0.82 1.63 0.96 2.16",
    fill: "#4b1498",
    fillRule: "nonzero"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.655738279223442, 12.596065405756235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.00 2.16 L 0.56 2.16 C 0.70 1.63 1.05 1.19 1.52 0.93 C 1.14 0.72 0.84 0.40 0.66 0.00 C 0.25 0.44 0.00 1.02 0.00 1.67 L 0.00 2.16",
    fill: "#4b1498",
    fillRule: "nonzero"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.24590246379375458, 0.983607355505228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.74 19.18 L 15.74 0.49 C 15.74 0.22 15.52 0.00 15.25 0.00 L 0.49 0.00 C 0.22 0.00 0.00 0.22 0.00 0.49 L 0.00 19.18 C 0.00 19.45 0.22 19.67 0.49 19.67 L 2.98 19.67 C 3.05 19.29 3.24 18.95 3.51 18.69 L 0.98 18.69 L 0.98 17.70 L 5.41 17.70 L 5.41 18.27 C 5.58 18.31 5.74 18.36 5.90 18.42 L 5.90 14.75 L 4.43 14.75 L 4.43 13.28 C 4.43 12.14 4.98 11.14 5.83 10.51 C 5.28 10.16 4.92 9.55 4.92 8.85 C 3.83 8.85 2.95 7.97 2.95 6.89 C 2.95 6.57 3.03 6.29 3.16 6.02 C 3.02 5.63 2.95 5.22 2.95 4.80 C 2.95 2.69 4.66 0.98 6.76 0.98 L 8.97 0.98 C 11.08 0.98 12.79 2.69 12.79 4.80 C 12.79 5.22 12.71 5.63 12.58 6.02 C 12.71 6.29 12.79 6.57 12.79 6.89 C 12.79 7.97 11.90 8.85 10.82 8.85 C 10.82 9.55 10.45 10.16 9.90 10.51 C 10.76 11.14 11.31 12.14 11.31 13.28 L 11.31 14.75 L 9.84 14.75 L 9.84 16.72 C 10.38 16.72 10.87 16.94 11.23 17.30 C 11.41 17.24 11.60 17.21 11.80 17.21 C 12.35 17.21 12.84 17.43 13.19 17.79 C 13.38 17.73 13.57 17.70 13.77 17.70 C 14.74 17.71 15.55 18.42 15.70 19.34 C 15.72 19.29 15.74 19.24 15.74 19.18 M 5.41 15.74 L 5.41 16.72 L 0.98 16.72 L 0.98 15.74 L 5.41 15.74",
    fill: "#4b1498",
    fillRule: "nonzero"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.06557409465313, 6.885246638208628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.00 0.00 L 0.00 1.97 C 0.54 1.97 0.98 1.53 0.98 0.98 C 0.98 0.44 0.54 0.00 0.00 0.00",
    fill: "#4b1498",
    fillRule: "nonzero"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.180328533053398, 2.950820330530405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.40 2.95 L 1.48 2.92 C 1.79 2.82 2.09 2.69 2.37 2.53 C 2.01 2.14 1.72 1.68 1.51 1.17 L 2.42 0.80 C 2.95 2.11 4.19 2.95 5.60 2.95 L 6.46 2.95 L 6.89 2.95 C 7.23 2.95 7.55 3.05 7.83 3.20 C 7.85 3.08 7.87 2.96 7.87 2.83 C 7.87 1.27 6.60 0.00 5.04 0.00 L 2.83 0.00 C 1.27 0.00 0.00 1.27 0.00 2.83 C 0.00 2.96 0.02 3.08 0.04 3.20 C 0.32 3.05 0.64 2.95 0.98 2.95 L 1.40 2.95",
    fill: "#4b1498",
    fillRule: "nonzero"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.180328533053398, 14.26229465380311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.84 5.41 C 9.29 5.41 8.85 5.85 8.85 6.39 L 8.85 5.90 C 8.85 5.36 8.41 4.92 7.87 4.92 C 7.33 4.92 6.89 5.36 6.89 5.90 L 6.89 5.41 C 6.89 4.87 6.45 4.43 5.90 4.43 C 5.36 4.43 4.92 4.87 4.92 5.41 L 4.92 0.98 C 4.92 0.44 4.48 0.00 3.93 0.00 C 3.39 0.00 2.95 0.44 2.95 0.98 L 2.95 8.06 C 2.95 6.87 1.99 5.90 0.80 5.90 C 0.36 5.90 0.00 6.26 0.00 6.70 C 0.00 6.82 0.03 6.94 0.08 7.05 L 0.67 8.23 C 0.88 8.64 0.98 9.09 0.98 9.55 L 0.98 10.82 C 0.98 13.54 3.18 15.74 5.90 15.74 C 8.62 15.74 10.82 13.54 10.82 10.82 L 10.82 6.39 C 10.82 5.85 10.38 5.41 9.84 5.41",
    fill: "#4b1498",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTeams);
export default __webpack_public_path__ + "static/media/feature-teams.67213bcbb5f3cf66508f74622644aeac.svg";
export { ForwardRef as ReactComponent };